import crypto from 'crypto';

const createHashFromProperty = property => {
  if (property === null || property === undefined) return null;
  return crypto.createHash('sha256').update(String(property)).digest('hex');
};

export default createHashFromProperty;
